import mitt from 'mitt';

export enum EVENT {
  NOTIFICATION = 'notification',
  YANBI_CHANGE = 'yanbi_change',
  ADMIN_CHANGE = 'admin_change',
  UPDATE_USER = 'update_user', // 购买成功
  UPDATE_PROJECT_TIP = 'update_project_tip', // 首次打开更新内容弹窗
  FIND_PWD = 'find_pwd', // 找回密码
  SWITCH_WECHAT_LOGIN = 'switch_wechat_login', // 切换微信登录
}

export const emitter = mitt<{
  [EVENT.YANBI_CHANGE]: undefined;
  [EVENT.ADMIN_CHANGE]: undefined;
  [EVENT.UPDATE_USER]: undefined;
  [EVENT.UPDATE_PROJECT_TIP]: undefined;
  [EVENT.FIND_PWD]: undefined;
  [EVENT.SWITCH_WECHAT_LOGIN]: undefined;
}>();
